export const FeeNature = {
    INCOME: 'INCOME',
    EXPENSE: 'EXPENSE',
    TAX: 'TAX',
};
